import React, { useEffect, useState } from 'react';
import TauriSectionModalVisual from '../../TauriSectionBaseVisual/TauriSectionModalVisual/TauriSectionModalVisual';
import TauriSectionModalMultiVisual from '../../TauriSectionBaseVisual/TauriSectionModalMultiVisual/TauriSectionModalMultiVisual';
import setting from '../../../config.json';
import appURL from '../../../appURL.json';
import OpalAccordionItem from '../../OpalAccordionItem/OpalAccordionItem';
import './OpalPeopleVisual.css';
import { useBaseProvider } from '../../../BaseManager/BaseManager';

const OpalPeopleVisual = ({ chartConfig, chartData, chartOptions, columnSize, rowSize, palettes, themes, chartPalettes }) => {
    const [selectedVisual, setSelectedVisual] = useState(null);
    const [selectedData, setSelectedData] = useState(null);
    const [modalPosition, setModalPosition] = useState({ x: 0, y: 0 });
    const [search, setSearch] = useState('');
    const [selectedCard, setSelectedCard] = useState(null);
    const [subordinates, setSubordinates] = useState([]);

    const { signalRConnection } = useBaseProvider();

    const handleDataPointSelection = (event) => {
        const title = chartConfig.binding.context.point.onClick.selectedValueColumn;
        const modalTitle = chartConfig.binding.context.point.onClick.selectedTitle;
        const selectedDesc = chartData[0][chartConfig.binding.data.title];
        const selectedVal = chartData[0][title];
        const selectedTitle = chartConfig.title;

        if (chartConfig.binding.context.point.onClick.visual || Array.isArray(chartConfig.binding.context.point.onClick.visuals)) {
            let selectedVisual = null;
            if (chartConfig.binding.context.point.onClick.visuals) {
                selectedVisual = chartConfig.binding.context.point.onClick.visuals;
            } else {
                selectedVisual = chartConfig.binding.context.point.onClick.visual;
            }

            setSelectedVisual(selectedVisual);
            setSelectedData({ title, selectedDesc, selectedVal, selectedTitle, modalTitle });

            const tauriElement = document.querySelector('.tauri-host-container');
            if (tauriElement) {
                if (event) {
                    let posX = event.clientX;
                    let posY = event.clientY;
                    if ((event.clientX + setting.modalMinWidth) > window.innerWidth) {
                        posX = event.clientX - setting.modalMinWidth;
                    }
                    if ((event.clientY + setting.modalMinHeight) > window.innerHeight) {
                        posY = event.clientY - setting.modalMinHeight;
                    }

                    setModalPosition({ x: posX, y: posY });
                }
            }
        }
    };

    const selectedItem = () => {

    }

    useEffect(() => {
        if (!signalRConnection) return;

        const updateSubordinateStatus = (empID, newStatus) => {
            setSubordinates(prev =>
                prev.map(sub =>
                    sub.employee?.id === empID
                        ? { ...sub, status: newStatus }
                        : sub
                )
            );
        };

        const handleEmployeeStartDay = async (empID) => {
            updateSubordinateStatus(empID, "Started");
        }

        const handleEmployeeEndDay = async (empID) => {
            updateSubordinateStatus(empID, "Ended");
        }

        const handleEmployeeStartCoverage = async (empID) => {
            // Set employee status to InCoverage
            updateSubordinateStatus(empID, "InCoverage");
        }

        const handleEmployeeEndCoverage = async (empID) => {
            // Set employee status back to Started
            updateSubordinateStatus(empID, "Started");
        }

        signalRConnection.on("StartDay", handleEmployeeStartDay);
        signalRConnection.on("EndDay", handleEmployeeEndDay);
        signalRConnection.on("InCoverage", handleEmployeeStartCoverage);
        signalRConnection.on("CoverageEnded", handleEmployeeEndCoverage);
    }, [signalRConnection])

    const fetchSubordinates = async () => {
        try {
            const storedPermission = localStorage.getItem("permission");
            const permission = JSON.parse(atob(storedPermission));
            const token = localStorage.getItem("token");
            const devId = localStorage.getItem("devId");
            const c_id = localStorage.getItem("c_id");
            const response = await fetch(`${appURL.API_GetSubordinates}/${Number(permission?.coverage?.employee_id)}/${c_id}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                    'X-ETR-DeviceID': devId
                }
            });

            if (!response.ok) {
                return;
            }

            const data = await response.json();
            setSubordinates(data);
        } catch (err) {

        }
    }

    useEffect(() => {
        fetchSubordinates();
    }, [])

    return (
        <>
            <div className='chart-content' >
                <OpalAccordionItem
                    items={subordinates}
                    search={search}
                    onSelectItem={selectedItem}
                    type={"v4"}
                    selectedCard={selectedCard}
                    setSelectedCard={setSelectedCard}
                />
            </div>
            {selectedVisual && (
                chartConfig.binding.context.point.onClick.visuals ? (
                    <TauriSectionModalMultiVisual
                        show={selectedVisual !== null}
                        onHide={() => setSelectedVisual(null)}
                        selectedData={selectedData}
                        visual={selectedVisual}
                        columnSize={columnSize}
                        rowSize={rowSize}
                        style={{ top: modalPosition.y, left: modalPosition.x }}
                        palettes={palettes}
                        themes={themes}
                    />
                ) : (
                    <TauriSectionModalVisual
                        show={selectedVisual !== null}
                        onHide={() => setSelectedVisual(null)}
                        selectedData={selectedData}
                        visual={selectedVisual}
                        columnSize={columnSize}
                        rowSize={rowSize}
                        style={{ top: modalPosition.y, left: modalPosition.x }}
                        palettes={palettes}
                        themes={themes}
                    />
                )
            )}
        </>
    );
};

export default OpalPeopleVisual;
